import { Avatar, Box, Grid, Stack, styled, TextField, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getGridSingleSelectOperators } from "@mui/x-data-grid-pro";
import { zipWith } from "lodash";
import { stringToColor } from "./formatString";
import SingleSelectInterval from "./SingleSelectInterval";
import Translate from "./Translate";
import DateInterval from "./DateInterval";
import { Error, Opacity } from "@mui/icons-material";

// Mårten: Genererad av Co-pilot och tweakad. Hanterar owerflow på kolumnrubrikens text.
// Expanderar klippt rubrik till en label vid mouseover
const GridHeaderHandlesOverflow = styled("span")(({ theme }) => ({
  display: "inline-block",
  whiteSpace: "nowrap",
  alignItems: "center",
  overflow: "hidden",
  textOverflow: "ellipsis",
  //maxWidth: '100%',
  transition: "all 0.3s ease",
  cursor: "default",
  fontWeight: "700",

  "&:hover": {
    left: 0, // fix för vänsterställda kolumner
    right: 0,
    whiteSpace: "nowrap",
    overflow: "visible",
    backgroundColor: theme.palette.background.paper,
    zIndex: 1000,
    position: "absolute",
    padding: "4px",
    paddingRight: "7px",
    boxShadow: theme.shadows[2],
    borderRadius: "4px",
  },
}));

export function IconAndLabelColumnHeader(props) {
  // verticalAlign: middle - för att få texten centrerad i höjdled
  return (
    <GridHeaderHandlesOverflow>
      {props.icon ? <props.icon sx={{ verticalAlign: "middle", marginRight: ".5rem" }} /> : null}
      {props.label}
    </GridHeaderHandlesOverflow>
  );
}

export function TableAvatar2({
  image,
  showNameAndEmailOnly,
  name,
  email,
  orgNo,
  externalActorNo,
  city,
  observationNote,
}) {
  if (showNameAndEmailOnly === true) {
    return (
      <Grid container direction="column" justifyContent="center" style={{ maxWidth: "300px", height: "100%" }}>
        <Typography
          variant="body2"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
          title={name}
        >
          {name}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
          title={email}
        >
          {email}
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} alignItems="center" wrap="nowrap" style={{ maxWidth: "300px", height: "100%" }}>
      <Grid item flexShrink={0}>
        <Avatar style={{ backgroundColor: stringToColor(name) }} src={image}>
          {image == null && name?.length > 0 ? name[0] : ""}
        </Avatar>
      </Grid>
      <Grid item>
        <Box lineHeight={1.2}>
          <Typography
            variant="body2"
            fontWeight="bold"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={name}
          >
            {name}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={email}
          >
            {email}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            {orgNo}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            {externalActorNo}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            {city}
          </Typography>
        </Box>
      </Grid>
      {!!observationNote && (
        <Grid container flexShrink={0}>
          <Tooltip title={observationNote} className="endAdornmentObservationNote" arrow>
            <Error />
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
}

export function TableAvatar2BorderRadius({ image, title, subtitle, subtitle2 }) {
  return (
    <Grid container spacing={4} style={{ maxWidth: "300px" }}>
      <Grid size={2}>
        <Avatar src={image} variant="rounded"></Avatar>
      </Grid>
      <Grid size={10}>
        <Box lineHeight={1.2}>
          <Typography
            variant="body2"
            fontWeight="bold"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={title}
          >
            {title}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={subtitle}
          >
            {subtitle}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={subtitle2}
          >
            {subtitle2}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export function TableAvatar({
  src = "",
  variant = "circular",
  title = "",
  subtitle = "",
  href = false,
  hideImage,
  boldTitle = true,
}) {
  if (!Array.isArray(subtitle)) {
    subtitle = [subtitle];
  } else {
    //Om vi kanske vill topställa text (tableAvatararTop finns inte i nuläget)
    //className='tableAvatar tableAvatararTop';
  }
  /*  const attr = {
    className: 'tableAvatar',
  };
  if (href) {
    //attr.to = href;
  } */

  function avatarSx(src, title) {
    if ((src === "null" || src === null) && title?.length) {
      // blir ibland strängen "null"
      return { bgcolor: stringToColor(title) };
    }
    return null;
  }

  return href ? (
    <div className="tableAvatar">
      {!hideImage && (
        <Link to={href}>
          <Avatar src={src} variant={variant} alt={title} sx={avatarSx(src, title)}>
            {/* visa intial om det inte finns någon url */}
            {(src && null) || (title.length && title[0]) || null}
          </Avatar>
        </Link>
      )}
      <div>
        <Link to={href} className={"tableAvatarTitle" + (boldTitle ? " bold" : "")}>
          {title}
        </Link>
        {subtitle.map((row, index) => (
          <div className="tableAvatarSubs" key={index}>
            {row}
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className="tableAvatar">
      {!hideImage && (
        <Avatar src={src} variant={variant} alt={title} sx={avatarSx(src, title)}>
          {/* visa intial om det inte finns någon url */}
          {(src && null) || (title.length && title[0]) || null}
        </Avatar>
      )}
      <div>
        <div className={"tableAvatarTitle" + (boldTitle ? " bold" : "")}>{title}</div>
        {subtitle.map((row, index) => (
          <div className="tableAvatarSubs" key={index}>
            {row}
          </div>
        ))}
      </div>
    </div>
  );
}

export function getGridColDefForSingleSelect(filterValueOptions, addBetweenOperator) {
  // Just modify the normal filter operators for singleSelect
  const operators = getGridSingleSelectOperators()
    .filter((op) => op.value === "is")
    .map((op) => ({
      ...op,
      label: Translate.get("Is"),
      getApplyFilterFn: (filterItem, column) => {
        if (
          !filterItem.field ||
          !filterItem.value || // Note this means filters for value 0 will be skipped
          !filterItem.operator
        ) {
          return null;
        }

        return (value, row, column, apiRef) => {
          return value && value === filterItem.value;
        };
      },
    }));

  if (addBetweenOperator) {
    operators.push({
      label: Translate.get("Between"),
      value: "between",
      getApplyFilterFn: (filterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null;
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null;
        }
        return (value, row, column, apiRef) => {
          return value != null && filterItem.value[0] <= value && value <= filterItem.value[1];
        };
      },
      InputComponent: SingleSelectInterval,
      InputComponentProps: { valueOptions: filterValueOptions },
    });
  }

  return {
    type: "singleSelect",
    valueOptions: filterValueOptions,
    filterOperators: operators,
  };
}

export function getGridColDefForArrayValues(filterValueOptions, compareValues = null) {
  // Just modify the normal filter operators for singleSelect
  const isInArrayValueFilterOpreator = getGridSingleSelectOperators()
    .filter((op) => op.value === "is")
    .map((op) => ({
      ...op,
      getApplyFilterFn: (filterItem, column) => {
        if (
          !filterItem.field ||
          !filterItem.value || // Note this means filters for value 0 will be skipped
          !filterItem.operator
        ) {
          return null;
        }

        return (value, row, column, apiRef) => {
          return value && value.includes(filterItem.value);
        };
      },
      // Denna verkar inte funka. Borde göra så att filter-tooltip säger ex: "Roll är Kontaktperson" istället för "Roll är 3"
      // getValueAsString: (value) => {
      //   return Translate.getActorType(value);
      // },
    }));

  const defaultCompareValues = (value1, value2) => {
    value1 = value1 ?? 0;
    value2 = value2 ?? 0;

    if (value1 > value2) {
      return 1;
    }

    if (value1 < value2) {
      return -1;
    }

    return 0;
  };

  // Will sort based on comparison of the first element, then by the second etc.
  const arrayComparator = (array1, array2) => {
    const compare = compareValues ?? defaultCompareValues;
    const zippedArrays = zipWith(array1, array2, compare);
    const result =
      zippedArrays.length > 0
        ? zippedArrays
            .map((value, index) => Math.pow(10, zippedArrays.length - 1 - index) * value)
            .reduce((acc, val) => acc + val)
        : 0;
    return result;
  };

  return {
    type: "singleSelect",
    valueOptions: filterValueOptions,
    filterOperators: isInArrayValueFilterOpreator,
    sortComparator: arrayComparator,
  };
}

export function getGridColDefForDateRange() {
  const operators = [
    {
      label: Translate.get("DateRange"),
      value: "between",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value || !filterItem.value.length) {
          return null;
        }

        const [start, end] = filterItem.value;
        return (value, row, column, apiRef) => {
          if (!value) {
            return false;
          }

          const date = new Date(value);
          return date >= start && date <= end;
        };
      },
      InputComponent: DateInterval,
    },
  ];

  return {
    type: "date",
    filterOperators: operators,
  };
}
